import axios from 'axios';
import { encode as base64_encode } from 'base-64';
import MaterialIcon from 'material-icons-react';
import React from 'react';
import { Table } from 'react-materialize';
import ReactTooltip from 'react-tooltip';
import { retornarCookie } from '../../services/cookieservice';
import {
  adicionarAgregado,
  adicionarInativo,
  listarAgregados,
  listarInativos,
  obterConfiguracaoNivel2,
  removerAgregado,
  removerInativo,
} from '../../services/nivel2service';
import './ListaElegibilidadesPage.css';

const { REACT_APP_API, REACT_APP_URL_INSTANCE } = process.env;

const parseBooleanEnv = (value) => {
  const normalized = (value || '')
    .toString()
    .trim()
    .replace(/^['\"]|['\"]$/g, '')
    .toLowerCase();

  return ['true', '1', 'sim', 'yes', 'y'].includes(normalized);
};

const FORCAR_FLUXO_LEGADO_VIDAS = parseBooleanEnv(
  process.env.REACT_APP_FORCAR_FLUXO_LEGADO_VIDAS
);

export default class ListaElegibilidadesPage extends React.Component {
  state = {
    elegibilidades: [],
    vidasrestantes: undefined,
    concluirElegibilidade: false,
    oportunidadeAtual: undefined,
    configuracaoNivel2: undefined,
    isNivel2: false,
    possuiInativos: false,
    possuiAgregados: false,
    listaInativos: [],
    listaAgregados: [],
    novoInativoTipoArtigo: 'Art30',
    novoInativoDataNascimento: '',
    novoInativoDataDesligamento: '',
    novoInativoElegibilidadeId: '',
    erroInativo: '',
    novoAgregadoTipoVinculo: 'Conjuge',
    novoAgregadoDataNascimento: '',
    novoAgregadoElegibilidadeId: '',
    erroAgregado: '',
    exibeCarregamentoNivel2: false,
  };

  componentDidMount() {
    this.inicializarPagina();
    window.addEventListener('focus', this.recarregarDadosElegibilidade);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.recarregarDadosElegibilidade);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  getOportunidadeId = () => this.props.oportunidade.OportunidadeID;

  handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      this.recarregarDadosElegibilidade();
    }
  };

  recarregarDadosElegibilidade = async () => {
    await Promise.all([
      this.listarElegibilidades(),
      this.carregarVidasRestantes(),
      this.carregarContextoNivel2(),
    ]);
  };

  isTruthy = (valor) =>
    valor === true || valor === 1 || valor === '1' || valor === 'true' || valor === 'True';

  isNivel2Opportunity = (oportunidade, configuracaoNivel2) => {
    const nivelRaw = oportunidade?.NivelOportunidade ?? oportunidade?.nivelOportunidade;
    const qtdeVidasRaw = oportunidade?.QtdeVidas ?? oportunidade?.qtdeVidas;
    const nivel = Number(nivelRaw);
    const qtdeVidas = Number(qtdeVidasRaw);
    const minVidas = Number(configuracaoNivel2?.MinVidas ?? configuracaoNivel2?.minVidas ?? 30);
    const maxVidas = Number(configuracaoNivel2?.MaxVidas ?? configuracaoNivel2?.maxVidas ?? 99);

    const isNivel2ByRange =
      !Number.isNaN(qtdeVidas) &&
      !Number.isNaN(minVidas) &&
      !Number.isNaN(maxVidas) &&
      qtdeVidas >= minVidas &&
      qtdeVidas <= maxVidas;

    return nivel === 2 || isNivel2ByRange;
  };

  handleDistribuirVidas = async () => {
    try {
      const result = this.props.distribuirVidas && this.props.distribuirVidas();
      if (result && typeof result.then === 'function') {
        await result;
      }
    } finally {
      // Refresh lists so newly saved elegibilidades are immediately selectable on this screen.
      this.recarregarDadosElegibilidade();
    }
  };

  inicializarPagina = async () => {
    await Promise.all([this.carregarOportunidade(), this.recarregarDadosElegibilidade()]);
  };

  carregarContextoNivel2 = async () => {
    if (FORCAR_FLUXO_LEGADO_VIDAS) {
      this.setState({
        configuracaoNivel2: undefined,
        isNivel2: false,
        listaInativos: [],
        listaAgregados: [],
        possuiInativos: false,
        possuiAgregados: false,
      });
      return;
    }

    try {
      const oportunidadeAtual = await this.carregarOportunidade(false);

      const oportunidade = oportunidadeAtual || this.props.oportunidade || {};
      const isNivel2 = this.isNivel2Opportunity(oportunidade, undefined);

      if (!isNivel2) {
        this.setState({
          configuracaoNivel2: undefined,
          isNivel2: false,
          listaInativos: [],
          listaAgregados: [],
          possuiInativos: false,
          possuiAgregados: false,
        });
        return;
      }

      const configuracaoNivel2 = await obterConfiguracaoNivel2().catch(() => undefined);

      this.setState({ configuracaoNivel2, isNivel2 });

      const oportunidadeId = this.getOportunidadeId();
      const [listaInativos, listaAgregados] = await Promise.all([
        listarInativos(oportunidadeId),
        listarAgregados(oportunidadeId),
      ]);

      this.setState({
        listaInativos: listaInativos || [],
        listaAgregados: listaAgregados || [],
        possuiInativos:
          Boolean(oportunidade?.PossuiInativos || oportunidade?.possuiInativos) ||
          Boolean((listaInativos || []).length),
        possuiAgregados:
          Boolean(oportunidade?.PossuiAgregados || oportunidade?.possuiAgregados) ||
          Boolean((listaAgregados || []).length),
      });
    } catch (e) {
      this.setState({ isNivel2: false });
    }
  };

  setLoadingNivel2 = (value) => this.setState({ exibeCarregamentoNivel2: value });

  normalizarDataParaISO = (valor) => {
    const texto = (valor || '').toString().trim();
    if (!texto) {
      return '';
    }

    const matchBr = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!matchBr) {
      return '';
    }

    const [, dia, mes, ano] = matchBr;
    if (!this.isDataCalendarioValida(ano, mes, dia)) {
      return '';
    }

    return `${ano}-${mes}-${dia}`;
  };

  isDataCalendarioValida = (ano, mes, dia) => {
    const anoNum = parseInt(ano, 10);
    const mesNum = parseInt(mes, 10);
    const diaNum = parseInt(dia, 10);

    if (
      Number.isNaN(anoNum) ||
      Number.isNaN(mesNum) ||
      Number.isNaN(diaNum) ||
      mesNum < 1 ||
      mesNum > 12 ||
      diaNum < 1 ||
      diaNum > 31
    ) {
      return false;
    }

    const data = new Date(Date.UTC(anoNum, mesNum - 1, diaNum));
    return (
      data.getUTCFullYear() === anoNum &&
      data.getUTCMonth() === mesNum - 1 &&
      data.getUTCDate() === diaNum
    );
  };

  aplicarMascaraData = (valor) => {
    const numeros = (valor || '').toString().replace(/\D/g, '').slice(0, 8);

    if (numeros.length <= 2) {
      return numeros;
    }

    if (numeros.length <= 4) {
      return `${numeros.slice(0, 2)}/${numeros.slice(2)}`;
    }

    return `${numeros.slice(0, 2)}/${numeros.slice(2, 4)}/${numeros.slice(4)}`;
  };

  getErroDateFieldByStateKey = (stateKey) =>
    stateKey === 'novoAgregadoDataNascimento' ? 'erroAgregado' : 'erroInativo';

  handleChangeData = (stateKey) => (event) => {
    const valorMascarado = this.aplicarMascaraData(event.target.value);
    this.setState({ [stateKey]: valorMascarado });
  };

  handleBlurData = (stateKey) => () => {
    const valorAtual = (this.state[stateKey] || '').toString().trim();
    const erroKey = this.getErroDateFieldByStateKey(stateKey);

    if (!valorAtual) {
      this.setState({ [stateKey]: '', [erroKey]: '' });
      return;
    }

    const dataIso = this.normalizarDataParaISO(valorAtual);
    if (valorAtual.length !== 10 || !dataIso) {
      this.setState({ [stateKey]: '', [erroKey]: '' });
      return;
    }

    const [ano, mes, dia] = dataIso.split('-');
    this.setState({ [stateKey]: `${dia}/${mes}/${ano}`, [erroKey]: '' });
  };

  formatarDataTabela = (valor) => {
    const texto = (valor || '').toString().trim();
    const matchIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
    if (matchIso) {
      return `${matchIso[3]}/${matchIso[2]}/${matchIso[1]}`;
    }

    const matchBr = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    return matchBr ? texto : '';
  };

  calcularIdade = (dataNascimentoIso) => {
    const nascimento = new Date(dataNascimentoIso);
    const hoje = new Date();

    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();

    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade -= 1;
    }

    return idade;
  };

  calcularMesesInatividade = (dataDesligamentoIso) => {
    const deslig = new Date(dataDesligamentoIso);
    const hoje = new Date();

    return (
      (hoje.getFullYear() - deslig.getFullYear()) * 12 +
      (hoje.getMonth() - deslig.getMonth())
    );
  };

  adicionarNovoInativo = async () => {
    const {
      novoInativoTipoArtigo,
      novoInativoDataNascimento,
      novoInativoDataDesligamento,
      novoInativoElegibilidadeId,
      configuracaoNivel2,
    } = this.state;

    const dataNascimentoIso = this.normalizarDataParaISO(novoInativoDataNascimento);
    const dataDesligamentoIso = this.normalizarDataParaISO(novoInativoDataDesligamento);

    if (!novoInativoTipoArtigo || !dataNascimentoIso || !dataDesligamentoIso || !novoInativoElegibilidadeId) {
      this.setState({ erroInativo: 'Preencha os campos obrigatórios do inativo (dd/mm/aaaa).' });
      return;
    }

    const idade = this.calcularIdade(dataNascimentoIso);
    if (idade > (configuracaoNivel2?.IdadeMaximaInativo || 0)) {
      this.setState({
        erroInativo: `Idade do inativo excede o máximo de ${configuracaoNivel2?.IdadeMaximaInativo} anos.`,
      });
      return;
    }

    const meses = this.calcularMesesInatividade(dataDesligamentoIso);
    if (
      novoInativoTipoArtigo === 'Art30' &&
      meses > (configuracaoNivel2?.TempoMaxInatividadeArt30 || 0)
    ) {
      this.setState({ erroInativo: 'Tempo máximo de inatividade Art 30 excedido.' });
      return;
    }

    if (
      novoInativoTipoArtigo === 'Art31' &&
      meses > (configuracaoNivel2?.TempoMaxInatividadeArt31 || 999)
    ) {
      this.setState({ erroInativo: 'Tempo máximo de inatividade Art 31 excedido.' });
      return;
    }

    this.setLoadingNivel2(true);

    try {
      const oportunidadeId = this.getOportunidadeId();
      await adicionarInativo({
        OportunidadeId: parseInt(oportunidadeId, 10),
        ElegibilidadeId: parseInt(novoInativoElegibilidadeId, 10),
        TipoArtigo: novoInativoTipoArtigo,
        DataNascimento: `${dataNascimentoIso}T00:00:00`,
        DataDesligamento: `${dataDesligamentoIso}T00:00:00`,
      });

      const listaInativos = await listarInativos(oportunidadeId);
      this.setState({
        listaInativos: listaInativos || [],
        possuiInativos: true,
        novoInativoDataNascimento: '',
        novoInativoDataDesligamento: '',
        novoInativoElegibilidadeId: '',
        erroInativo: '',
      });
    } catch (error) {
      this.setState({ erroInativo: 'Não foi possível adicionar o inativo.' });
    } finally {
      this.setLoadingNivel2(false);
    }
  };

  removerInativoRegistrado = async (id) => {
    if (!window.confirm('Remover inativo?')) {
      return;
    }

    this.setLoadingNivel2(true);
    try {
      const oportunidadeId = this.getOportunidadeId();
      await removerInativo(oportunidadeId, id);
      const listaInativos = await listarInativos(oportunidadeId);
      this.setState({
        listaInativos: listaInativos || [],
        possuiInativos: Boolean((listaInativos || []).length),
      });
    } catch (e) {
      this.setState({ erroInativo: 'Não foi possível remover o inativo.' });
    } finally {
      this.setLoadingNivel2(false);
    }
  };

  adicionarNovoAgregado = async () => {
    const {
      novoAgregadoTipoVinculo,
      novoAgregadoDataNascimento,
      novoAgregadoElegibilidadeId,
      configuracaoNivel2,
    } = this.state;

    const dataNascimentoIso = this.normalizarDataParaISO(novoAgregadoDataNascimento);

    if (!novoAgregadoTipoVinculo || !dataNascimentoIso || !novoAgregadoElegibilidadeId) {
      this.setState({ erroAgregado: 'Preencha os campos obrigatórios do agregado (dd/mm/aaaa).' });
      return;
    }

    const idade = this.calcularIdade(dataNascimentoIso);
    const maxTitularAgregado = configuracaoNivel2?.IdadeMaximaTitularAgregado || 0;
    const maxConjuge = configuracaoNivel2?.IdadeMaximaConjuge || 0;
    const maxFilho = configuracaoNivel2?.IdadeMaximaFilho || 0;

    if (
      (novoAgregadoTipoVinculo === 'Titular' ||
        novoAgregadoTipoVinculo === 'Agregado Titular') &&
      idade > maxTitularAgregado
    ) {
      this.setState({ erroAgregado: `Idade excede o máximo de ${maxTitularAgregado} anos.` });
      return;
    }

    if (novoAgregadoTipoVinculo === 'Conjuge' && idade > maxConjuge) {
      this.setState({ erroAgregado: `Idade excede o máximo de ${maxConjuge} anos.` });
      return;
    }

    if (novoAgregadoTipoVinculo === 'Filho' && idade > maxFilho) {
      this.setState({ erroAgregado: `Idade excede o máximo de ${maxFilho} anos.` });
      return;
    }

    this.setLoadingNivel2(true);
    try {
      const oportunidadeId = this.getOportunidadeId();
      await adicionarAgregado({
        OportunidadeId: parseInt(oportunidadeId, 10),
        ElegibilidadeId: parseInt(novoAgregadoElegibilidadeId, 10),
        TipoVinculo: novoAgregadoTipoVinculo,
        DataNascimento: `${dataNascimentoIso}T00:00:00`,
      });

      const listaAgregados = await listarAgregados(oportunidadeId);
      this.setState({
        listaAgregados: listaAgregados || [],
        possuiAgregados: true,
        novoAgregadoDataNascimento: '',
        novoAgregadoElegibilidadeId: '',
        erroAgregado: '',
      });
    } catch (error) {
      this.setState({ erroAgregado: 'Não foi possível adicionar o agregado.' });
    } finally {
      this.setLoadingNivel2(false);
    }
  };

  removerAgregadoRegistrado = async (id) => {
    if (!window.confirm('Remover agregado?')) {
      return;
    }

    this.setLoadingNivel2(true);
    try {
      const oportunidadeId = this.getOportunidadeId();
      await removerAgregado(oportunidadeId, id);
      const listaAgregados = await listarAgregados(oportunidadeId);
      this.setState({
        listaAgregados: listaAgregados || [],
        possuiAgregados: Boolean((listaAgregados || []).length),
      });
    } catch (e) {
      this.setState({ erroAgregado: 'Não foi possível remover o agregado.' });
    } finally {
      this.setLoadingNivel2(false);
    }
  }

  async carregarOportunidade(updateState = true) {
    const params = {
      oportunidadeID: this.props.oportunidade.OportunidadeID,
      IdAgenteVendas: retornarCookie('IdAgenteVenda'),
      CdAgenteVendas: retornarCookie('CdAgenteVendas'),
      multiplasPropostas: false,
    };

    const res = await axios.get(`${REACT_APP_API}oportunidade/OportunidadePorId`, { params });
    if (updateState) {
      this.setState({ oportunidadeAtual: res.data });
    }
    return res.data;
  }

  async listarElegibilidades() {
    const IdAgenteVendas = retornarCookie('IdAgenteVenda');

    const params = {
      oportunidadeID: this.props.oportunidade.OportunidadeID,
      IdAgenteVendas,
    };

    const res = await axios.get(`${REACT_APP_API}elegibilidade/elegibilidadesResumida`, { params });
    const elegibilidades = [
      ...res.data.map((x) => {
        const ListaPlanos = [...x.Planos].toString();
        return { ...x, ListaPlanos };
      }),
    ];

    this.setState({ elegibilidades });
  }

  async carregarVidasRestantes() {
    const IdAgenteVendas = retornarCookie('IdAgenteVenda');

    const params = {
      oportunidadeID: this.props.oportunidade.OportunidadeID,
      IdAgenteVendas,
    };

    const res = await axios.get(`${REACT_APP_API}elegibilidade/VidasRestantes`, { params });
    const vidasrestantes = res.data;
    let concluirElegibilidade = false;

    if (vidasrestantes === 0) concluirElegibilidade = true;

    this.setState({ vidasrestantes, concluirElegibilidade });
  }

  async excluirElegibilidade(elegibilidadeID) {
    const IdAgenteVendas = retornarCookie('IdAgenteVenda');

    const params = {
      oportunidadeID: this.props.oportunidade.OportunidadeID,
      elegibilidadeID,
      IdAgenteVendas,
    };

    if (window.confirm("Tem certeza que deseja excluir esta elegibilidade?") == true) {
      await axios.delete(`${REACT_APP_API}elegibilidade`, { params });
      await this.recarregarDadosElegibilidade();
    }
  }

  async continuar() {

    if (this.state.vidasrestantes > 0) {
      alert("Não é possível prosseguir com a proposta sem destribuir todas as vidas.")
    } else {
      const nivelOportunidade =
        this.state.oportunidadeAtual?.NivelOportunidade ??
        this.state.oportunidadeAtual?.nivelOportunidade ??
        this.props.oportunidade?.NivelOportunidade ??
        this.props.oportunidade?.nivelOportunidade;

      const reembolsoRaw =
        this.state.oportunidadeAtual?.ReembolsoDiferenciado ??
        this.state.oportunidadeAtual?.reembolsoDiferenciado ??
        this.props.oportunidade?.ReembolsoDiferenciado ??
        this.props.oportunidade?.reembolsoDiferenciado;

      const qtdeVidasRaw =
        this.state.oportunidadeAtual?.QtdeVidas ??
        this.state.oportunidadeAtual?.qtdeVidas ??
        this.props.oportunidade?.QtdeVidas ??
        this.props.oportunidade?.qtdeVidas;

      const oportunidadeFluxo = {
        NivelOportunidade: nivelOportunidade,
        QtdeVidas: qtdeVidasRaw,
      };

      const ehNivel2ComReembolso =
        this.isNivel2Opportunity(oportunidadeFluxo, this.state.configuracaoNivel2) &&
        this.isTruthy(reembolsoRaw);

      if (ehNivel2ComReembolso) {
        const redirectTo = `${REACT_APP_URL_INSTANCE}${base64_encode('NavigationBar,ReembolsoNivel2Page')}`;
        const auth = `&Auth=${base64_encode(retornarCookie('Auth'))}`;
        const params = `&OportunidadeID=${this.props.oportunidade.OportunidadeID}`;
        document.location.href = `${redirectTo}${auth}${params}`;
      } else if(retornarCookie("Filial") != "3"){
        const redirectTo = `${REACT_APP_URL_INSTANCE}${base64_encode('NavigationBar,InformacoesComplementaresPage')}`;
        const auth = `&Auth=${base64_encode(retornarCookie('Auth'))}`;
        const params = `&OportunidadeID=${this.props.oportunidade.OportunidadeID}`;
        document.location.href = `${redirectTo}${auth}${params}`;
      } else {
        const redirectTo = `${REACT_APP_URL_INSTANCE}${base64_encode('NavigationBar,GerarPropostaPage')}`;
        const auth = `&Auth=${base64_encode(retornarCookie('Auth'))}`;
        const params = `&OportunidadeID=${this.props.oportunidade.OportunidadeID}`;
        document.location.href = `${redirectTo}${auth}${params}`;
      }
    }

  }

  render() {
    const {
      elegibilidades,
      concluirElegibilidade,
      isNivel2,
      exibeCarregamentoNivel2,
      possuiInativos,
      possuiAgregados,
      listaInativos,
      listaAgregados,
      novoInativoTipoArtigo,
      novoInativoDataNascimento,
      novoInativoDataDesligamento,
      novoInativoElegibilidadeId,
      erroInativo,
      novoAgregadoTipoVinculo,
      novoAgregadoDataNascimento,
      novoAgregadoElegibilidadeId,
      erroAgregado,
    } = { ...this.state };

    return (
      <>
        <div className="row container">
          <Table className="centered">
            <thead>
              <tr>
                <th data-field="NomeElegibilidade">Nome elegibilidade</th>
                <th data-field="VidasDistribuidas">Vidas distribuidas</th>
                <th data-field="ListaPlanos">Lista de planos</th>
                <th data-field="acoes">Ações</th>
              </tr>
            </thead>
            <tbody>
              {elegibilidades.length > 0 &&
                elegibilidades.map((elegibilidade) => (
                  <tr>
                    <td>{elegibilidade.Nome}</td>
                    <td>{elegibilidade.QtdeVidas}</td>
                    <td>{elegibilidade.ListaPlanos}</td>
                    <td>
                      <span
                        data-tip
                        data-for="excluir_cpt"
                        className="gridIcon center"
                        onClick={() => this.excluirElegibilidade(elegibilidade.Id)}
                      >
                        <MaterialIcon icon="delete_forever" color="#172972" />
                      </span>
                      <ReactTooltip id="excluir_cpt" aria-haspopup="true" role="example">
                        <p>Excluir Elegibilidade</p>
                      </ReactTooltip>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>

          {isNivel2 && elegibilidades.length > 0 && (
            <div className="col s12 m12 l12 nivel2-after-eleg-grid">
              <h5 className="nivel2-inline-title">Informações Nível 2 dependentes de elegibilidade</h5>

              <div className="nivel2-inline-section">
                <p>
                  <label>
                    <input
                      type="checkbox"
                      checked={possuiInativos}
                      onChange={(e) => this.setState({ possuiInativos: e.target.checked })}
                    />
                    <span>
                      Possui beneficiários em extensão de benefício pelos Art 30 ou 31 da lei 9.656?
                    </span>
                  </label>
                </p>

                {possuiInativos && (
                  <>
                    <div className="row nivel2-inline-labels nivel2-inline-fields-4">
                      <div className="col s3">
                        <small className="nivel2-field-label">Tipo (Art 30/31)</small>
                      </div>
                      <div className="col s3">
                        <small className="nivel2-field-label">Data de nascimento</small>
                      </div>
                      <div className="col s3">
                        <small className="nivel2-field-label">Data de desligamento</small>
                      </div>
                      <div className="col s3">
                        <small className="nivel2-field-label">Elegibilidade</small>
                      </div>
                    </div>
                    <div className="row nivel2-inline-fields nivel2-inline-fields-4">
                      <div className="input-field col s3">
                        <select
                          className="browser-default"
                          value={novoInativoTipoArtigo}
                          onChange={(e) => this.setState({ novoInativoTipoArtigo: e.target.value })}
                        >
                          <option value="Art30">Art 30</option>
                          <option value="Art31">Art 31</option>
                        </select>
                      </div>
                      <div className="input-field col s3">
                        <input
                          type="text"
                          placeholder="dd/mm/aaaa"
                          inputMode="numeric"
                          maxLength={10}
                          value={novoInativoDataNascimento}
                          onChange={this.handleChangeData('novoInativoDataNascimento')}
                          onBlur={this.handleBlurData('novoInativoDataNascimento')}
                        />
                      </div>
                      <div className="input-field col s3">
                        <input
                          type="text"
                          placeholder="dd/mm/aaaa"
                          inputMode="numeric"
                          maxLength={10}
                          value={novoInativoDataDesligamento}
                          onChange={this.handleChangeData('novoInativoDataDesligamento')}
                          onBlur={this.handleBlurData('novoInativoDataDesligamento')}
                        />
                      </div>
                      <div className="input-field col s3">
                        <select
                          className="browser-default"
                          value={novoInativoElegibilidadeId}
                          onChange={(e) => this.setState({ novoInativoElegibilidadeId: e.target.value })}
                        >
                          <option value="">Elegibilidade</option>
                          {elegibilidades.map((eleg) => (
                            <option key={eleg.Id || eleg.id} value={eleg.Id || eleg.id}>
                              {(eleg.Nome || eleg.nome)} ({eleg.QtdeVidas || eleg.qtdeVidas || 0} vidas)
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <button
                      type="button"
                      className="OmintButton"
                      onClick={this.adicionarNovoInativo}
                      disabled={exibeCarregamentoNivel2}
                    >
                      Adicionar Inativo
                    </button>
                    {erroInativo && <p className="nivel2-inline-error">{erroInativo}</p>}

                    <table className="nivel2-inline-table">
                      <thead>
                        <tr>
                          <th>Artigo</th>
                          <th>Nascimento</th>
                          <th>Desligamento</th>
                          <th>Tempo Inatividade</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listaInativos.map((item) => (
                          <tr key={item.Id || item.id}>
                            <td>{item.TipoArtigo || item.tipoArtigo}</td>
                            <td>{this.formatarDataTabela(item.DataNascimento || item.dataNascimento || '')}</td>
                            <td>{this.formatarDataTabela(item.DataDesligamento || item.dataDesligamento || '')}</td>
                            <td>{item.TempoInatividade || item.tempoInatividade} meses</td>
                            <td>
                              <button
                                type="button"
                                className="nivel2-inline-icon-btn nivel2-inline-icon-btn--danger"
                                title="Remover"
                                aria-label="Remover"
                                onClick={() => this.removerInativoRegistrado(item.Id || item.id)}
                                disabled={exibeCarregamentoNivel2}
                              >
                                <MaterialIcon icon="delete" color="#b00020" size={16} />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}
              </div>

              <div className="nivel2-inline-section">
                <p>
                  <label>
                    <input
                      type="checkbox"
                      checked={possuiAgregados}
                      onChange={(e) => this.setState({ possuiAgregados: e.target.checked })}
                    />
                    <span>
                      Possui beneficiários agregados (dependentes dos titulares, exceto cônjuge e filhos/enteados)?
                    </span>
                  </label>
                </p>

                {possuiAgregados && (
                  <>
                    <div className="row nivel2-inline-labels nivel2-inline-fields-3">
                      <div className="col s4">
                        <small className="nivel2-field-label">Grau de parentesco</small>
                      </div>
                      <div className="col s4">
                        <small className="nivel2-field-label">Data de nascimento</small>
                      </div>
                      <div className="col s4">
                        <small className="nivel2-field-label">Elegibilidade</small>
                      </div>
                    </div>
                    <div className="row nivel2-inline-fields nivel2-inline-fields-3">
                      <div className="input-field col s4">
                        <select
                          className="browser-default"
                          value={novoAgregadoTipoVinculo}
                          onChange={(e) => this.setState({ novoAgregadoTipoVinculo: e.target.value })}
                        >
                          <option value="Titular">Titular</option>
                          <option value="Agregado Titular">Agregado Titular</option>
                          <option value="Conjuge">Conjuge</option>
                          <option value="Filho">Filho</option>
                        </select>
                      </div>
                      <div className="input-field col s4">
                        <input
                          type="text"
                          placeholder="dd/mm/aaaa"
                          inputMode="numeric"
                          maxLength={10}
                          value={novoAgregadoDataNascimento}
                          onChange={this.handleChangeData('novoAgregadoDataNascimento')}
                          onBlur={this.handleBlurData('novoAgregadoDataNascimento')}
                        />
                      </div>
                      <div className="input-field col s4">
                        <select
                          className="browser-default"
                          value={novoAgregadoElegibilidadeId}
                          onChange={(e) => this.setState({ novoAgregadoElegibilidadeId: e.target.value })}
                        >
                          <option value="">Elegibilidade</option>
                          {elegibilidades.map((eleg) => (
                            <option key={eleg.Id || eleg.id} value={eleg.Id || eleg.id}>
                              {(eleg.Nome || eleg.nome)} ({eleg.QtdeVidas || eleg.qtdeVidas || 0} vidas)
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <button
                      type="button"
                      className="OmintButton"
                      onClick={this.adicionarNovoAgregado}
                      disabled={exibeCarregamentoNivel2}
                    >
                      Adicionar Agregado
                    </button>
                    {erroAgregado && <p className="nivel2-inline-error">{erroAgregado}</p>}

                    <table className="nivel2-inline-table">
                      <thead>
                        <tr>
                          <th>Vínculo</th>
                          <th>Nascimento</th>
                          <th>Idade</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listaAgregados.map((item) => (
                          <tr key={item.Id || item.id}>
                            <td>{item.TipoVinculo || item.tipoVinculo}</td>
                            <td>{this.formatarDataTabela(item.DataNascimento || item.dataNascimento || '')}</td>
                            <td>{item.Idade || item.idade}</td>
                            <td>
                              <button
                                type="button"
                                className="nivel2-inline-icon-btn nivel2-inline-icon-btn--danger"
                                title="Remover"
                                aria-label="Remover"
                                onClick={() => this.removerAgregadoRegistrado(item.Id || item.id)}
                                disabled={exibeCarregamentoNivel2}
                              >
                                <MaterialIcon icon="delete" color="#b00020" size={16} />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}
              </div>
            </div>
          )}

          {concluirElegibilidade ? (
            <div className="col s12 m12 l12 right-align">
              <br />
              <button type="button" onClick={() => this.continuar()} className="OmintButton">
                Continuar
              </button>
              <br />
            </div>
          ) : (
            <div className="col s12 m12 l12 right-align">
              <br />
              <button type="button" onClick={this.handleDistribuirVidas} className="OmintButton">
                Distribuir Vidas
              </button>
              <br />
            </div>
          )}
        </div>
      </>
    );
  }
}
